module.exports = __webpack_public_path__ + "img/132ne.05c7c8dc.svg";